import { Box } from "@material-ui/core";
import React from "react";
import RegularButton from "./Button";
import { animations } from "helpers/animations";

export const SubmitBtns = ({
  onClose,
  onSubmit,
  loading = false,
  submitBtnText = "Confirmar",
  confirmColor = "info",
  cancelColor = "transparent",
  cancelText = "Cancelar",
  disabled = false
}) => {
  return (
    <Box
      className={animations.fadeIn}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 20,
        gap: 8,
        animationDelay: ".5s",
      }}
    >
      <RegularButton color={cancelColor} onClick={onClose} disabled={loading}>
        {cancelText}
      </RegularButton>
      <RegularButton color={confirmColor} onClick={onSubmit} loading={loading} disabled={disabled}>
        {submitBtnText}
      </RegularButton>
    </Box>
  );
};
